import { useCompany } from "@admin/hooks/useCompany";
import { useLocationsWithLicenses } from "@admin/hooks/useLocationsWithLicenses";
import { LicenseTypes, useCommonStore } from "@enos-monorepo/lib";
import { useMemo } from "react";

import { InfoBankLocationTabs } from "./InfoBankLocationTabs";

export function InformationBankPage() {
  const { company } = useCompany();
  const { locations, isPending } = useLocationsWithLicenses(LicenseTypes.food);
  const { foodLocation } = useCommonStore();
  const currentFoodLocation = useMemo(() => {
    if (foodLocation && locations) {
      return locations.find((l) => l.id === foodLocation) || locations[0];
    }
    return locations && locations.length > 0 ? locations[0] : undefined;
  }, [foodLocation, locations]);
  return (
    <InfoBankLocationTabs
      selectedLocation={currentFoodLocation}
      companyId={company?.companyId}
      locations={locations}
      isLoading={isPending}
    />
  );
}
